import { useEffect, useState } from "react";
import Slider from "react-slick";
import Tile from "../components/Tile";
import Menu from "./Menu";
import FooterInView from "./FooterInView";
import UserConsent from "./UserConsent";

const FreeGamesByFawesome = () => {
  const [games, setGames] = useState(null);

  let gameHeroImage = "./assets/images/iptv-game-banner-new.webp";

  const [paddingTop, setPaddingTop] = useState(0);
  const [isOutOfViewport, setIsOutOfViewport] = useState(false);

  let gameDomain = "games.freeawesometv.com";
  if (window.location.hostname === "fawesome.tv") {
    gameDomain = "games.fawesome.tv";
  }
  let gameJsonUrl = `https://${gameDomain}/assets/data/game.json`;

  const calculatePadding = () => {
    // Select the elements by class name
    //const bgBodyTertiary = document.querySelector(".bg-body-tertiary");
    const herotitle = document.querySelector(".herotitle");
    const herotitleSub = document.querySelector(".herotitleSub");
    const ctaIntro = document.querySelector(".cta-intro");
    if (ctaIntro) {
      const rect = ctaIntro.getBoundingClientRect();
      const outOfViewport2 =
        rect.top >= window.innerHeight || // Below the viewport
        rect.bottom <= 0 || // Above the viewport
        rect.left >= window.innerWidth || // To the right of viewport
        rect.right <= 0; // To the left of viewport

      const outOfViewport =
        rect.top >= 0 && // Top is within viewport (not above)
        rect.bottom <= window.innerHeight - 200 && // Bottom is within viewport (not below)
        rect.left >= 0 && // Left is within viewport (not to the left)
        rect.right <= window.innerWidth; // Right is within viewport (not to the right)

      setIsOutOfViewport(outOfViewport);
      if (!outOfViewport) {
        // Calculate the total height of the selected elements
        const totalHeight =
          //(bgBodyTertiary?.offsetHeight || 0) +
          (herotitle?.offsetHeight || 0) +
          (herotitleSub?.offsetHeight || 0) +
          (ctaIntro?.offsetHeight || 0);

        // Get viewport height and calculate padding-top
        const viewportHeight = window.innerHeight;
        const calculatedPadding = viewportHeight - totalHeight - 100 - 75;
        // Set the padding-top dynamically
        setPaddingTop(calculatedPadding);
      }
    }
  };

  const getImageUrl = (item) => {
    let imageUrl = `https://${gameDomain}${item?.image_url}`;
    return imageUrl;
  };

  const cleanString = (input) => {
    return input.replace(/[\s\W_]+/g, "").toLowerCase();
  };

  useEffect(() => {
    const navLinks = document.querySelectorAll(".bg-body-tertiary .nav-link");
    const searchInput = document.querySelectorAll(
      ".bg-body-tertiary #search-input"
    );
    navLinks.forEach((link) => {
      link.classList.add("gtm-lp", "gtm-nav-link");
    });
    searchInput.forEach((link) => {
      link.classList.add("gtm-lp", "gtm-search-text");
    });

    // Calculate padding on mount
    calculatePadding();

    // Add an event listener to recalculate on window resize
    window.addEventListener("resize", calculatePadding);

    // Cleanup the event listener when component unmounts
    return () => {
      window.removeEventListener("resize", calculatePadding);
    };
  }, []);

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 1,
    swipeToSlide: true,
    centerMode: false,
    variableWidth: false,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  //fetch("./assets/data/game.json")
  useEffect(() => {
    fetch(gameJsonUrl)
      .then((res) => res.json())
      .then((data) => setGames(data))
      .catch(() => setGames(null));
  }, []);

  return (
    <>
      <Menu></Menu>
      <section className="container-fluid">
        <div className="heroSection">
          <div
            className="herotitleContGame"
            style={paddingTop > 0 ? { paddingTop: `${paddingTop}px` } : {}}
          >
            <h1>Free Games By Fawesome</h1>
            <p>New games added regularly to keep the fun going!</p>
          </div>
        </div>

        <div className="heropicCont">
          <img src={gameHeroImage} className="heropic" alt="fawesome" />
        </div>

        <div className="slider-view">
          {games?.rows?.map((row, rowIndex) => (
            <div id="titles" className="padVerGame" key={rowIndex}>
              <div className="mb-2">
                <h4 className="RowTitle">{row?.title}</h4>
              </div>

              <div className="titles-slide">
                <Slider {...sliderSettings}>
                  {row?.list?.map((item, key) => (
                    <div className="titleItemGame" key={key}>
                      <div className="titlePic gtm-lp gtm-title-thumbnail">
                        <a
                          href={`./games/${item.id}/${cleanString(item.title)}`}
                          className="titleLink"
                        >
                          <img
                            // src={item?.image_url}
                            src={getImageUrl(item)}
                            alt={item?.title}
                            className="titleImage"
                          />
                        </a>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          ))}
        </div>
      </section>
      <FooterInView></FooterInView>
      <UserConsent></UserConsent>
    </>
  );
};

export default FreeGamesByFawesome;
